module.exports = __webpack_public_path__ + "assets/img/12e5c5eb20c94bea7e816f261907bd3f.png";